/* eslint-disable */
/**
 * 工具 v1.0
 */
/**------------------------------------------ */

/**
 * 去除两边的空格
 */
String.prototype.trim = function () {
  return this.replace(/(^\s*)|(\s*$)/g, '')
}
/**
 * 替换字符串所有指定字符
 */
String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, 'gm'), s2)
}

var utilView = {
  config: {
    localName: 'dongao_jijiao',
    diffTime: ''
  },
  tool: {
    isNull: function (s) {
      return s == ''
    },
    isPhone: function (s) {
      return /^(0|86|17951)?(1[1-9][0-9])[0-9]{8}$/.test(s)
    },
    isEmail: function (s) {
      return /^[a-zA-Z0-9]{1}([\._a-zA-Z0-9-]+)(\.[_a-zA-Z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+){1,3}$/.test(
        s
      )
    },
    isChinese: function (s) {
      return /^[\u4e00-\u9fa5]+$/.test(s)
    },
    idCard: function (s) {
      return /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(s)
    },
    tirm: function (s) {
      return s.replace(/^\s+|\s+$/gm, '')
    }
  },
  /**
   * 获取url 中的指定参数值
   * eg:http://www.dongao.cn?v=2&c=3 //getUrlParam('v') return 2
   *
   */
  getUrlParam: function (s) {
    var reg = new RegExp('(^|&)' + s + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return decodeURIComponent(r[2])
    return null
  },
  getHashParam(s) {
    var paramsObj = {};
    let url = decodeURIComponent(window.location.search || window.location.hash)
    let strs
    if (url.indexOf("?") != -1) {
        // hash模式进此判断
        if (window.location.hash) {
            strs = url.split("?")[1].toString().split("&")
            // history模式
        } else {
            strs = url.substr(1).split("&")
        }
        // 循环遍历并添加到对象中
        for (let i = 0; i < strs.length; i++) {
            paramsObj[strs[i].split("=")[0]] = strs[i].split("=")[1]
        }
    }
    return paramsObj[s] || null
  },
  getDataType: function (d) {
    return Object.prototype.toString.call(d).match(/\[object\s([\S]*?)\]/)[1]
  },
  /**
   * 是不是钉钉或微信
   */
  isDevice: function () {
    var ua = window.navigator.userAgent.toLowerCase()
    if (
      ua.match(/MicroMessenger/i) == 'micromessenger' ||
      ua.match(/dingtalk/i) == 'dingtalk'
    ) {
      return true
    } else {
      return false
    }
  },
  isWeChat: function () {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } else {
      return false
    }
  },
  isMobile: function () {
    var ua = window.navigator.userAgent
    if (
      ua.match(
        /(phone|iPhone|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      var isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
      var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isAndroid) {
        return 1
      } else if (isiOS) {
        return 2
      } else {
        return true
      }
    } else {
      return false
    }
  },
  /**
   * 是不是钉钉
   */
  isDD: function () {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/dingtalk/i) == 'dingtalk') {
      return true
    } else {
      return false
    }
  },
  /**
   * 浙江app
   * @returns
   */
  isZjApp: function () {
    var ua = window.navigator.userAgent.toLowerCase()
    return ua.indexOf('dtdreamweb') > -1 || ua.indexOf('gft_hanweb') > -1 || ua.indexOf('_xjbt') > -1
    
  },
  isJxApp: function () {
    var ua = window.navigator.userAgent.toLowerCase()
    return ua.indexOf('gft_hanweb') > -1
  },
  /**
   * 支付宝、小程序
   * @returns
   */
  isAliplay: function () {
    var ua = window.navigator.userAgent.toLowerCase()
    return ua.indexOf('alipay') > -1 && ua.indexOf('miniprogram') > -1
  },
  /**
   * 返回时间点 时分秒
   */
  getLeftDownTime: function (now) {
    var hour = parseInt((now % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      min = parseInt((now % (1000 * 60 * 60)) / (1000 * 60)),
      sec = parseInt((now % (1000 * 60)) / 1000)
    return [
      hour.toString().padStart(2, 0),
      min.toString().padStart(2, 0),
      sec.toString().padStart(2, 0)
    ].join(':')
  },
  /**
   * 格式化手机***
   * */
  getFormatPhone: function (tel) {
    if (tel && tel.length === 11) {
      return tel.substring(0, 3) + '****' + tel.substr(tel.length - 4)
    } else {
      return ''
    }
  },
  /**
   * [setLocal:localStorage]
   *
   * @return  {[undefined]}
   */
  setLocal: function (key, value) {
    if (window.localStorage) {
      var duration = new Date().getTime()
      var obj =
        JSON.parse(localStorage.getItem(utilView.config.localName)) || {}
      obj[key] = obj[key] || {}
      obj[key]['value'] = value
      obj[key]['time'] = duration
      localStorage.setItem(utilView.config.localName, JSON.stringify(obj))
    }
  },
  /**
   * [getLocal:localStorage]
   *
   * @return  {[undefined]}
   */
  getLocal: function (key, day) {
    //day 超过n天 local'失效'
    if (window.localStorage) {
      var duration = new Date().getTime(),
        n = day || 1
      var str = localStorage.getItem(utilView.config.localName)
      if (str) {
        var data = JSON.parse(str)
        if (
          data[key] &&
          data[key]['time'] - duration < n * 24 * 60 * 60 * 1000
        ) {
          return data[key].value
        }
      }
    }
  },
  /**
   * [setLocal:存入session]
   *
   * @return  {[undefined]}
   */
  setSession: function (key, value) {
    if (window.sessionStorage) {
      var duration = new Date().getTime()
      var obj =
        JSON.parse(sessionStorage.getItem(utilView.config.localName)) || {}
      obj[key] = obj[key] || {}
      obj[key]['value'] = value
      obj[key]['time'] = duration
      sessionStorage.setItem(utilView.config.localName, JSON.stringify(obj))
    }
  },
  /**
   * [getLocal:取出session]
   *
   * @return  {[undefined]}
   */
  getSession: function (key, day) {
    //day 超过n天 local'失效'
    if (window.sessionStorage) {
      var duration = new Date().getTime(),
        n = day || 1
      var str = sessionStorage.getItem(utilView.config.localName)
      if (str) {
        var data = JSON.parse(str)
        if (
          data[key] &&
          data[key]['time'] - duration < n * 24 * 60 * 60 * 1000
        ) {
          return data[key].value
        }
      }
    }
  },
  setCookie: function (cname, cvalue, exdays) {
    var d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    // var expires = 'expires=' + d.toGMTString()
    // document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/;'
    document.cookie = cname + '=' + cvalue + '; path=/;'
  },
  getCookie: function (cname) {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim()
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
    }
    return ''
  },
  /**
   * [timeToStamp 字符串 转时间戳]
   *
   * @return  {[Number]}  [return stamp]
   */
  timeToStamp: function (date) {
    var stamp = ''
    if (date) {
      stamp = +new Date(date.replace('&#32;', ' ').replaceAll('-', '/'))
    } else {
      //如果不传参数得到的是当前服务器时间
      stamp = +new Date() + utilView.config.diffTime
    }
    return stamp
  },
  /**
   * [与服务器做差后得到2017-09-02 格式的日期]
   * type 为true 返回日期字符串带时分秒
   * @return  {[String]}  [return '2017-09-02']
   */
  getDate: function (type, s) {
    var date = !!s
      ? new Date(s)
      : new Date(+new Date() + utilView.config.diffTime)
    var m =
      date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : '0' + (date.getMonth() + 1)
    var d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
    var str = date.getFullYear() + '-' + m + '-' + d
    if (type) {
      var h = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      var mm =
        date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      var s =
        date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      str += ' ' + h + ':' + mm + ':' + s
    }
    return str
  },
  /**
   * 传入时间戳 返回 09：00：00
   */
  getDateTime: function (date) {
    var date = new Date(date),
      str = ''
    var h = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
    var mm = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    var s = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
    str += ' ' + h + ':' + mm + ':' + s
    return str
  },
  /**
   * [getTimeMD 得到4月1日格式的日期如果不是当前年份加上年]
   *
   * @return  {[String]}  [return '4月1日']
   */
  getTimeMD: function (dateStr) {
    var str =
      parseInt(dateStr.substr(5, 2)) +
      '月' +
      parseInt(dateStr.substr(8, 2)) +
      '日'
    return str
  },
  /**
   * [getTimeMS 得到一天内两个日期的时间段]
   *
   * @return  {[String]}  [return 得到09:00-10:00格式日期]
   */
  getTimeMS: function (d1, d2) {
    var str =
      d1.replace('&#32;', ' ').substr(11, 5) +
      '-' +
      d2.replace('&#32;', ' ').substr(11, 5)
    return str
  },
  /**
   * [getTimeHm 得到一个日期字符串的时和分]
   *
   * @return  {[String]}  [return '22:00']
   */
  getTimeHm: function (dateStr) {
    return dateStr.replace('&#32;', ' ').substr(11, 5)
  },
  /**
   * 将秒转为 时 分 秒
   * @param {*} s
   * @returns
   */
  getTimeCN: function (s) {
    var mss = s * 1000
    var days = parseInt(mss / (1000 * 60 * 60 * 24))
    var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
    var seconds = (mss % (1000 * 60)) / 1000
    return (
      (days * 24 + hours > 0 ? days * 24 + hours + ' 时 ' : '') +
      (minutes > 0 ? minutes + ' 分 ' : '') +
      seconds +
      ' 秒 '
    )
  },
  getServerTime: function () {
    var xhr = null
    if (window.XMLHttpRequest) {
      xhr = new window.XMLHttpRequest()
    } else {
      // ie
      xhr = new ActiveObject('Microsoft')
    }
    xhr.open('GET', '/', true)
    xhr.send(null)
    xhr.onreadystatechange = function () {
      var time, date
      if (xhr.readyState == 2) {
        time = xhr.getResponseHeader('Date')
        date = new Date(time)
        utilView.config.diffTime = date.getTime() - +new Date()
      }
    }
  },
  /**
   * [ajaxFn 简易版jQuery ajax封装]
   *
   * @return  {[undefined]}
   */
  decodeFn: function (s) {
    return decodeURIComponent(s)
  },
  /**
   * 随机数
   * @param num 随机几位数
   * @returns {number}
   */
  randomNum: function (n) {
    if (n > 21) return null
    var re = new RegExp('(\\d{' + n + '})(\\.|$)')
    var num = (Array(n - 1).join(0) + Math.pow(10, n) * Math.random()).match(
      re
    )[1]
    return num
  },
  /**
   * 获取累加
   * @param {*} numArr 数字数组
   * @returns {number}
   */
  sum: function (numArr) {
    var d = 0
    var sum = 0
    for (var key in numArr) {
      var str = '' + numArr[key]
      if (str.indexOf('.') != -1) {
        var temp = str.split('.')[1].length
        d = d < temp ? temp : d
      }
    }
    var m = Math.pow(10, d)
    for (var key in numArr) {
      sum += numArr[key] * m
    }
    return sum / m
  },
  /**
   * 格式化时间  时间戳转化为字符串
   * @param time  时间
   * @returns {string}
   */
  formatData: function (time) {
    var t = new Date(time),
      format = 'yyyy-MM-dd'
    var tf = function (i) {
      return (i < 10 ? '0' : '') + i
    }
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
      switch (a) {
        case 'yyyy':
          return tf(t.getFullYear())
          break
        case 'MM':
          return tf(t.getMonth() + 1)
          break
        case 'mm':
          return tf(t.getMinutes())
          break
        case 'dd':
          return tf(t.getDate())
          break
        case 'HH':
          return tf(t.getHours())
          break
        case 'ss':
          return tf(t.getSeconds())
          break
      }
    })
  },
  getTime: function () {
    return Math.round(+new Date() / 1000)
  },
  timestampToTime: function (timestamp) {
    var zero = function (date) {
      return date < 10 ? '0' + date : date
    }
    var date = new Date(timestamp * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear()
    var M = date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1
    var D = date.getDate()
    var h = date.getHours()
    var m = date.getMinutes()
    var s = date.getSeconds()
    return (
      zero(Y) +
      '-' +
      zero(M) +
      '-' +
      zero(D) +
      ' ' +
      zero(h) +
      ':' +
      zero(m) +
      ':' +
      zero(s)
    )
  },
  /**
   * 将 时:分:秒 格式数据转换为秒
   */
  parseTime2Second: function (playTime) {
    var timeArr = playTime.split(':')
    var seconds =
      parseInt(timeArr[0], 10) * 60 * 60 +
      parseInt(timeArr[1], 10) * 60 +
      parseInt(timeArr[2], 10)
    return seconds
  },
  /**
   * 数据md5加密
   * @param data 需要加密的数据
   * @returns {*}
   */
  md5Data: function (data, secretKey, ignoreSign = []) {
    delete data.sign
    var arr = [],
      str = '',
      strArr = []
    //   data.timestamp = utilView.timestampToTime(utilView.getTime());
    for (var i in data) {
      //遍历key
      arr.push(i)
    }
    for (var i in arr.sort()) {
      //排序并生成 加密串
      if (
        !(
          data[arr[i]] === '' ||
          data[arr[i]] === 'undefined' ||
          data[arr[i]] === undefined
        )
      ) {
        if (ignoreSign.indexOf(arr[i]) === -1) {
          strArr.push(arr[i] + '=' + data[arr[i]])
        }
      } else {
        delete data[arr[i]]
      }
    }
    str = strArr.join('&')
    str += secretKey //盐值
    data.sign = utilView.md5(str.replace(/undefined/gi, '')) //sign
    return data
  },
  //md5 加密
  md5: function (string) {
    function RotateLeft(lValue, iShiftBits) {
      return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits))
    }

    function AddUnsigned(lX, lY) {
      var lX4, lY4, lX8, lY8, lResult
      lX8 = lX & 0x80000000
      lY8 = lY & 0x80000000
      lX4 = lX & 0x40000000
      lY4 = lY & 0x40000000
      lResult = (lX & 0x3fffffff) + (lY & 0x3fffffff)
      if (lX4 & lY4) {
        return lResult ^ 0x80000000 ^ lX8 ^ lY8
      }
      if (lX4 | lY4) {
        if (lResult & 0x40000000) {
          return lResult ^ 0xc0000000 ^ lX8 ^ lY8
        } else {
          return lResult ^ 0x40000000 ^ lX8 ^ lY8
        }
      } else {
        return lResult ^ lX8 ^ lY8
      }
    }

    function F(x, y, z) {
      return (x & y) | (~x & z)
    }

    function G(x, y, z) {
      return (x & z) | (y & ~z)
    }

    function H(x, y, z) {
      return x ^ y ^ z
    }

    function I(x, y, z) {
      return y ^ (x | ~z)
    }

    function FF(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac))
      return AddUnsigned(RotateLeft(a, s), b)
    }

    function GG(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac))
      return AddUnsigned(RotateLeft(a, s), b)
    }

    function HH(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac))
      return AddUnsigned(RotateLeft(a, s), b)
    }

    function II(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac))
      return AddUnsigned(RotateLeft(a, s), b)
    }

    function ConvertToWordArray(string) {
      var lWordCount
      var lMessageLength = string.length
      var lNumberOfWords_temp1 = lMessageLength + 8
      var lNumberOfWords_temp2 =
        (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64
      var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16
      var lWordArray = Array(lNumberOfWords - 1)
      var lBytePosition = 0
      var lByteCount = 0
      while (lByteCount < lMessageLength) {
        lWordCount = (lByteCount - (lByteCount % 4)) / 4
        lBytePosition = (lByteCount % 4) * 8
        lWordArray[lWordCount] =
          lWordArray[lWordCount] |
          (string.charCodeAt(lByteCount) << lBytePosition)
        lByteCount++
      }
      lWordCount = (lByteCount - (lByteCount % 4)) / 4
      lBytePosition = (lByteCount % 4) * 8
      lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition)
      lWordArray[lNumberOfWords - 2] = lMessageLength << 3
      lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29
      return lWordArray
    }

    function WordToHex(lValue) {
      var WordToHexValue = '',
        WordToHexValue_temp = '',
        lByte,
        lCount
      for (lCount = 0; lCount <= 3; lCount++) {
        lByte = (lValue >>> (lCount * 8)) & 255
        WordToHexValue_temp = '0' + lByte.toString(16)
        WordToHexValue =
          WordToHexValue +
          WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2)
      }
      return WordToHexValue
    }

    function Utf8Encode(string) {
      string = string.replace(/\r\n/g, '\n')
      var utftext = ''
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n)
        if (c < 128) {
          utftext += String.fromCharCode(c)
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode((c >> 6) | 192)
          utftext += String.fromCharCode((c & 63) | 128)
        } else {
          utftext += String.fromCharCode((c >> 12) | 224)
          utftext += String.fromCharCode(((c >> 6) & 63) | 128)
          utftext += String.fromCharCode((c & 63) | 128)
        }
      }
      return utftext
    }
    var x = Array()
    var k, AA, BB, CC, DD, a, b, c, d
    var S11 = 7,
      S12 = 12,
      S13 = 17,
      S14 = 22
    var S21 = 5,
      S22 = 9,
      S23 = 14,
      S24 = 20
    var S31 = 4,
      S32 = 11,
      S33 = 16,
      S34 = 23
    var S41 = 6,
      S42 = 10,
      S43 = 15,
      S44 = 21
    string = Utf8Encode(string)
    x = ConvertToWordArray(string)
    a = 0x67452301
    b = 0xefcdab89
    c = 0x98badcfe
    d = 0x10325476
    for (k = 0; k < x.length; k += 16) {
      AA = a
      BB = b
      CC = c
      DD = d
      a = FF(a, b, c, d, x[k + 0], S11, 0xd76aa478)
      d = FF(d, a, b, c, x[k + 1], S12, 0xe8c7b756)
      c = FF(c, d, a, b, x[k + 2], S13, 0x242070db)
      b = FF(b, c, d, a, x[k + 3], S14, 0xc1bdceee)
      a = FF(a, b, c, d, x[k + 4], S11, 0xf57c0faf)
      d = FF(d, a, b, c, x[k + 5], S12, 0x4787c62a)
      c = FF(c, d, a, b, x[k + 6], S13, 0xa8304613)
      b = FF(b, c, d, a, x[k + 7], S14, 0xfd469501)
      a = FF(a, b, c, d, x[k + 8], S11, 0x698098d8)
      d = FF(d, a, b, c, x[k + 9], S12, 0x8b44f7af)
      c = FF(c, d, a, b, x[k + 10], S13, 0xffff5bb1)
      b = FF(b, c, d, a, x[k + 11], S14, 0x895cd7be)
      a = FF(a, b, c, d, x[k + 12], S11, 0x6b901122)
      d = FF(d, a, b, c, x[k + 13], S12, 0xfd987193)
      c = FF(c, d, a, b, x[k + 14], S13, 0xa679438e)
      b = FF(b, c, d, a, x[k + 15], S14, 0x49b40821)
      a = GG(a, b, c, d, x[k + 1], S21, 0xf61e2562)
      d = GG(d, a, b, c, x[k + 6], S22, 0xc040b340)
      c = GG(c, d, a, b, x[k + 11], S23, 0x265e5a51)
      b = GG(b, c, d, a, x[k + 0], S24, 0xe9b6c7aa)
      a = GG(a, b, c, d, x[k + 5], S21, 0xd62f105d)
      d = GG(d, a, b, c, x[k + 10], S22, 0x2441453)
      c = GG(c, d, a, b, x[k + 15], S23, 0xd8a1e681)
      b = GG(b, c, d, a, x[k + 4], S24, 0xe7d3fbc8)
      a = GG(a, b, c, d, x[k + 9], S21, 0x21e1cde6)
      d = GG(d, a, b, c, x[k + 14], S22, 0xc33707d6)
      c = GG(c, d, a, b, x[k + 3], S23, 0xf4d50d87)
      b = GG(b, c, d, a, x[k + 8], S24, 0x455a14ed)
      a = GG(a, b, c, d, x[k + 13], S21, 0xa9e3e905)
      d = GG(d, a, b, c, x[k + 2], S22, 0xfcefa3f8)
      c = GG(c, d, a, b, x[k + 7], S23, 0x676f02d9)
      b = GG(b, c, d, a, x[k + 12], S24, 0x8d2a4c8a)
      a = HH(a, b, c, d, x[k + 5], S31, 0xfffa3942)
      d = HH(d, a, b, c, x[k + 8], S32, 0x8771f681)
      c = HH(c, d, a, b, x[k + 11], S33, 0x6d9d6122)
      b = HH(b, c, d, a, x[k + 14], S34, 0xfde5380c)
      a = HH(a, b, c, d, x[k + 1], S31, 0xa4beea44)
      d = HH(d, a, b, c, x[k + 4], S32, 0x4bdecfa9)
      c = HH(c, d, a, b, x[k + 7], S33, 0xf6bb4b60)
      b = HH(b, c, d, a, x[k + 10], S34, 0xbebfbc70)
      a = HH(a, b, c, d, x[k + 13], S31, 0x289b7ec6)
      d = HH(d, a, b, c, x[k + 0], S32, 0xeaa127fa)
      c = HH(c, d, a, b, x[k + 3], S33, 0xd4ef3085)
      b = HH(b, c, d, a, x[k + 6], S34, 0x4881d05)
      a = HH(a, b, c, d, x[k + 9], S31, 0xd9d4d039)
      d = HH(d, a, b, c, x[k + 12], S32, 0xe6db99e5)
      c = HH(c, d, a, b, x[k + 15], S33, 0x1fa27cf8)
      b = HH(b, c, d, a, x[k + 2], S34, 0xc4ac5665)
      a = II(a, b, c, d, x[k + 0], S41, 0xf4292244)
      d = II(d, a, b, c, x[k + 7], S42, 0x432aff97)
      c = II(c, d, a, b, x[k + 14], S43, 0xab9423a7)
      b = II(b, c, d, a, x[k + 5], S44, 0xfc93a039)
      a = II(a, b, c, d, x[k + 12], S41, 0x655b59c3)
      d = II(d, a, b, c, x[k + 3], S42, 0x8f0ccc92)
      c = II(c, d, a, b, x[k + 10], S43, 0xffeff47d)
      b = II(b, c, d, a, x[k + 1], S44, 0x85845dd1)
      a = II(a, b, c, d, x[k + 8], S41, 0x6fa87e4f)
      d = II(d, a, b, c, x[k + 15], S42, 0xfe2ce6e0)
      c = II(c, d, a, b, x[k + 6], S43, 0xa3014314)
      b = II(b, c, d, a, x[k + 13], S44, 0x4e0811a1)
      a = II(a, b, c, d, x[k + 4], S41, 0xf7537e82)
      d = II(d, a, b, c, x[k + 11], S42, 0xbd3af235)
      c = II(c, d, a, b, x[k + 2], S43, 0x2ad7d2bb)
      b = II(b, c, d, a, x[k + 9], S44, 0xeb86d391)
      a = AddUnsigned(a, AA)
      b = AddUnsigned(b, BB)
      c = AddUnsigned(c, CC)
      d = AddUnsigned(d, DD)
    }
    var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d)
    return temp.toLowerCase()
  },
  install: function (app) {
    app.config.globalProperties.$util = utilView
  }
}
const loadJs = function (src, flag, callback) {
  var srcArr = [],
    srcType = Object.prototype.toString
      .call(src)
      .match(/\[object\s([\S]*?)\]/)[1],
    flagType = Object.prototype.toString
      .call(flag)
      .match(/\[object\s([\S]*?)\]/)[1],
    cont = 0
  if (flagType === 'Function') {
    callback = flag
  } else {
    if (flag) {
      callback && callback(flag)
      return
    }
  }
  if (srcType === 'Array') {
    srcArr = src
  } else if (srcType === 'String') {
    srcArr[0] = src
  } else {
    return
  }
  for (var i = 0; i < srcArr.length; i++) {
    var s = document.createElement('script')
    s.src = srcArr[i]
    s.async = true
    s.charset = 'utf-8'
    document.body.insertBefore(s, document.body.firstChild)
    ;(function (s) {
      s.onload = s.onreadystatechange = function () {
        if (!s.readyState || /loaded|complete/.test(s.readyState)) {
          cont++
          if (cont === srcArr.length) {
            callback && callback()
          }
        }
      }
    })(s)
  }
}
export default utilView
export { loadJs }
